exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".checkbox-group-input ul li + li {\n  margin-top: 10px;\n}\n", ""]);
